import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/sagivbengiat/cloned_projects/react-elastic-carousel/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Carousel, { consts } from 'react-elastic-carousel';
import Square from '../components/Square';
import Flex from '../components/Flex';
import Item from '../components/SimpleItem';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "renderpagination"
    }}>{`renderPagination`}</h1>
    <h3 {...{
      "id": "you-can-provide-custom-pagination-buttons"
    }}>{`You can provide custom pagination buttons.`}</h3>
    <h2 {...{
      "id": "signature"
    }}>{`Signature`}</h2>
    <ul>
      <li parentName="ul">{`You can pass a function that returns a react element,`}<br parentName="li"></br>
        {`This function is a `}<a parentName="li" {...{
          "href": "https://reactjs.org/docs/render-props.html"
        }}>{`render prop`}</a>{` and its signature is:  `}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`({ pages, activePage, onClick }) =>  {/* return your element here */}
`}</code></pre>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`pages`}</inlineCode>{` Array of page index.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`activePage`}</inlineCode>{` The current active page id.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`onClick`}</inlineCode>{` Is the hook to the inner `}<inlineCode parentName="li">{`onClick`}</inlineCode>{` of the `}<inlineCode parentName="li">{`Carousel`}</inlineCode>{`. You can attach it wherever you want within the returned component.`}</li>
    </ul>
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <Playground __position={0} __code={'<Carousel\n  itemsToShow={3}\n  renderPagination={({ pages, activePage, onClick }) => {\n    return (\n      <Flex direction=\"row\">\n        {pages.map(page => {\n          const isActivePage = activePage === page\n          return (\n            <Square\n              key={page}\n              onClick={() => onClick(page)}\n              active={isActivePage}\n            />\n          )\n        })}\n      </Flex>\n    )\n  }}\n>\n  <Item>1</Item>\n  <Item>2</Item>\n  <Item>3</Item>\n  <Item>4</Item>\n  <Item>5</Item>\n  <Item>6</Item>\n  <Item>7</Item>\n  <Item>8</Item>\n  <Item>9</Item>\n  <Item>10</Item>\n</Carousel>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Carousel,
      consts,
      Square,
      Flex,
      Item,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Carousel itemsToShow={3} renderPagination={({
        pages,
        activePage,
        onClick
      }) => {
        return <Flex direction="row" mdxType="Flex">
                        {pages.map(page => {
            const isActivePage = activePage === page;
            return <Square key={page} onClick={() => onClick(page)} active={isActivePage} mdxType="Square" />;
          })}
                    </Flex>;
      }} mdxType="Carousel">
        <Item mdxType="Item">1</Item>
        <Item mdxType="Item">2</Item>
        <Item mdxType="Item">3</Item>
        <Item mdxType="Item">4</Item>
        <Item mdxType="Item">5</Item>
        <Item mdxType="Item">6</Item>
        <Item mdxType="Item">7</Item>
        <Item mdxType="Item">8</Item>
        <Item mdxType="Item">9</Item>
        <Item mdxType="Item">10</Item>
    </Carousel>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      